import { render, staticRenderFns } from "./colors.vue?vue&type=template&id=77b8f191&scoped=true&"
import script from "./colors.vue?vue&type=script&lang=js&"
export * from "./colors.vue?vue&type=script&lang=js&"
import style0 from "./colors.vue?vue&type=style&index=0&id=77b8f191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8f191",
  null
  
)

export default component.exports